import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../../../services/shared';
import { DENIALS_TAG_TYPES } from './tags';

/**
 * Single base RTK Query API for the Denials backend (one `createApi` per backend).
 *
 * Intentionally EMPTY of endpoints — features inject their own via `denialsApi.injectEndpoints` in
 * `features/{x}/data/{x}Endpoints.ts` (mirrors `modules/claims/data/claimsApi.ts`). Never create a
 * second `createApi` for this backend from within this module. Import this base api by file path
 * (`../../../data/denialsApi`) from feature endpoint files, not via the `data` barrel, to avoid
 * import cycles.
 */
export const denialsApi = createApi({
  reducerPath: 'denialsApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.denials),
  tagTypes: DENIALS_TAG_TYPES,
  endpoints: () => ({}),
});
